import React from 'react'
import swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'
import Button from 'material-ui/Button';
import SettingsIcon from 'material-ui-icons/Settings'
import { withStyles } from 'material-ui/styles'

import SettingsModal from '../modals/settings'

const styles = theme => ({
    button: {
    }
})

const mySwal = withReactContent(swal)

const settingButton = (props) => {

    const handleClick = (e, isNotFirstVisit = true) => {
        mySwal({
            html: <SettingsModal onClick={() => mySwal.clickConfirm()} />,
            showConfirmButton: false,
            width: 900
        })
    }

    return (
        <Button color="inherit"
            className={props.classes.button}
            onClick={handleClick}>
            格式设置
        </Button>
    )
}

export default withStyles(styles)(settingButton)


// WEBPACK FOOTER //
// ./src/components/buttons/setting.js